import React from 'react';
import PropTypes from 'prop-types';

import { Text } from 'components/common/Elements/Elements';

import classes from './Network.module.scss';

const Network = data => {
  const {
    data: { name, dns, icon }
  } = data;

  return (
    <div className={classes.box}>
      <img
        className={classes.img}
        src={icon.url}
        width="32"
        height="32"
        alt=""
      />
      <Text className={classes.texts} type="p">
        <Text weight="b">{name}</Text>
        <Text size={2}>{dns}</Text>
      </Text>
    </div>
  );
};

Network.propTypes = {
  data: PropTypes.object
};

export default Network;
